import LoginForm from "../../components/loginForm/LoginForm";
import { Container } from "./LoginStyles";

const Login = () => {
  return (
    <Container>
      <LoginForm />
    </Container>
  );
};

export default Login;
